//
import type { UILoader, UIStoreState } from '@/types/Store'
import { defineStore } from 'pinia'

const defaultLoader = (): UILoader => ({
  name: null,
  show: false,
  data: {},
})

export const useUiStore = defineStore('ui', {
  state: (): UIStoreState => ({
    loader: defaultLoader(),
  }),
  actions: {
    loaderShow(payload: Partial<UILoader> & { name: string }) {
      this.loader = { name: payload.name, show: true, data: payload.data ?? {} }
    },
    loaderHide(payload?: Partial<Pick<UILoader, 'name'>>) {
      this.loader = { ...defaultLoader(), name: payload?.name ?? null }
    },
  },
})

export type UiStore = ReturnType<typeof useUiStore>
